export default __webpack_public_path__ + "static/media/canFeedbackImg.ce1f5ec5.svg";